<template>
    <div>
        <label
            :for="id"
            class="pb-[3px] text-sm font-medium leading-normal text-gray-700"
            :class="{ 'text-gray-400': disabled }"
        >
            {{ label }}
        </label>
        <div class="flex items-center gap-2">
            <input
                :id="id"
                type="color"
                class="h-[38px] w-10 shrink-0 cursor-pointer rounded-[6px] border border-gray-300 bg-white p-1 disabled:cursor-not-allowed"
                :value="swatch"
                :disabled="disabled"
                @input="
                    emit(
                        'update:modelValue',
                        ($event.target as HTMLInputElement).value
                    )
                "
            />
            <TextInput
                class="w-full"
                :model-value="modelValue"
                :disabled="disabled"
                :error="error"
                placeholder="Editor default"
                @update:modelValue="emit('update:modelValue', $event)"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { useId } from 'vue';

const props = defineProps({
    label: {
        type: String,
        required: true,
    },
    modelValue: {
        type: String,
        default: '',
    },
    error: {
        type: String,
        default: '',
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['update:modelValue']);

const id = useId();

/** The native picker only understands #rrggbb, so anything else shows white. */
const swatch = computed(() =>
    /^#[0-9a-fA-F]{6}$/.test(props.modelValue) ? props.modelValue : '#ffffff'
);
</script>
